export enum drawerType {
    PLAY_IN = 'PLAY_IN',
    SLIDES = 'SLIDES',
    SPOTLIGHT = 'SPOTLIGHT'
  }
